"use strict";

exports.__esModule = true;
exports.InstantaneousEventTickets = exports.InstantaneousEventComments = exports.InstantaneousEventAlerts = void 0;
exports.getEventCreator = getEventCreator;
exports.getEventDescription = getEventDescription;
exports.getEventId = getEventId;
exports.getEventTypes = getEventTypes;
exports.getInstantaneousTimelineEvents = getInstantaneousTimelineEvents;
var InstantaneousEventTickets = exports.InstantaneousEventTickets = "Tickets";
var InstantaneousEventAlerts = exports.InstantaneousEventAlerts = "Alerts";
var InstantaneousEventComments = exports.InstantaneousEventComments = "Comments";
function getEventTypes(props) {
  var getAlerts = props.getAlerts,
    getTickets = props.getTickets,
    getComments = props.getComments;
  var events = [];
  if (getTickets) {
    events.push(InstantaneousEventTickets);
  }
  if (getAlerts) {
    events.push(InstantaneousEventAlerts);
  }
  if (getComments) {
    events.push(InstantaneousEventComments);
  }
  return events;
}
function getEventId(eventType, event) {
  switch (eventType) {
    case InstantaneousEventTickets:
      return event.id;
    case InstantaneousEventAlerts:
      return event.id;
    case InstantaneousEventComments:
      return event.commentId;
    default:
      return null;
  }
}
function getEventDescription(eventType, event) {
  switch (eventType) {
    case InstantaneousEventTickets:
      return event.title;
    case InstantaneousEventAlerts:
      return event.description;
    case InstantaneousEventComments:
      return event.body;
    default:
      return null;
  }
}
function getEventCreator(eventType, event) {
  switch (eventType) {
    case InstantaneousEventTickets:
      return event.creatorId;
    case InstantaneousEventComments:
      return event.author;
    default:
      return null;
  }
}
function getInstantaneousTimelineEvents(_ref) {
  var data = _ref.data,
    eventTypes = _ref.eventTypes;
  return eventTypes.reduce(function (acc, eventType) {
    if (data && data[eventType]) {
      // support paged data repsonse object
      var content = data[eventType].content || data[eventType];
      acc = acc.concat(content.map(function (event) {
        var icon = event.icon,
          created = event.created;
        return {
          icon: icon,
          created: new Date(created).getTime(),
          description: getEventDescription(eventType, event),
          id: getEventId(eventType, event),
          creatorId: getEventCreator(eventType, event),
          eventType: eventType
        };
      }));
    }
    return acc;
  }, []);
}